// src/components/auth/AuthShell.tsx
import logoMark from "@/assets/SE_Mark_Blue@2x.png"
import topoBlue from "@/assets/Topo_Texture/Topo_Blue.svg"
import { Button } from "@/components/ui/button"

interface AuthShellProps {
  title: string
  description: string
  primaryLabel: string
  onPrimaryClick: () => void
  primaryIcon?: React.ReactNode
}

export function AuthShell({
  title,
  description,
  primaryLabel,
  onPrimaryClick,
  primaryIcon,
}: AuthShellProps) {
  return (
    <div
      className="relative flex min-h-screen items-center justify-center p-8"
      style={{
        backgroundImage: `url(${topoBlue})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* overlay for contrast, stronger in dark mode via .dark */}
      <div className="absolute inset-0 bg-black/20 dark:bg-black/50" />

      {/* glass card */}
      <div className="relative z-10 w-full max-w-lg rounded-2xl border border-border bg-card/30 shadow-xl backdrop-blur-md p-8 flex flex-col items-center gap-4">
        <img src={logoMark} alt="Sagepoint logo" className="w-[160px] mb-2" />

        <h1 className="text-2xl font-semibold text-center text-card-foreground">{title}</h1>

        <p className="text-sm text-muted-foreground text-center max-w-md">{description}</p>

        <Button
          onClick={onPrimaryClick}
          className="mt-4 w-full flex items-center justify-center gap-2 bg-primary text-primary-foreground hover:bg-primary/50 transition-colors"
        >
          {primaryLabel}
          {primaryIcon}
        </Button>
      </div>
    </div>
  )
}
